export default {
    "goal": "Goal.",
    "goal_team_only": "{{score}}Goal {{scoring_team}}!",
    "goal_team_player": "{{score}}Goal {{scoring_team}}! By {{scoring_player}}.",
    "own_goal_team_player": "{{score}}Goal {{scoring_team}}. Own goal by {{scoring_player}}.",

    "yellow_card": "Yellow card.",
    "yellow_card_team_only": "Yellow card {{team}}.",
    "yellow_card_team_player": "Yellow card {{team}}: {{player}}.",

    "red_card": "Red card.",
    "red_card_team_only": "Red card {{team}}.",
    "red_card_team_player": "Red card {{team}}: {{player}}.",

    "penalty": "Penalty.",
    "penalty_by_team": "Penalty, {{team}}.",

    "phase_kickoff": "Kickoff.",
    "kickoff_1st_half": "Kickoff first half.",
    "kickoff_2nd_half": "Kickoff second half.",
    "kickoff_1st_overtime": "Kickoff first overtime.",
    "kickoff_2nd_overtime": "Kickoff second overtime.",
    "start_of_penalties": "Penalty shootout.",

    "phase_end": "Half-time.",
    "end_1st_half": "Half-time.",
    "end_2nd_half": "Break before overtime.",
    "end_1st_overtime": "Half-time during overtime",
    "end_2nd_overtime": "Break before penalties.",

    "game_over": "Match over.",
    "game_over_1": "Match over, {{winning_team}} wins at {{stadium}}. {{score_home}}-{{score_visiting}}",
    "game_over_2": "Match over, draw at {{stadium}}. {{score_home}}-{{score_visiting}}",
    "game_over_3": "Match over, {{winning_team}} wins. {{score_home}}-{{score_visiting}}",
    "game_over_4": "Match over. {{score_home}}-{{score_visiting}}",

    "shot": "Shot",
    "blocked_shot": "Blocked shot",
    "shot_on_goal": "Shot on goal",
    "shot_wide": "Shot wide",
    "shot_on_bar": "Shot on crossbar",
    "shot_on_post": "Shot on post",

    "blocked_shot_team": "Shot by {{team}}. Shot blocked.",
    "blocked_shot_team_player": "Shot by {{player}}, {{team}}. Shot blocked.",

    "heading": "Heading",
    "heading_on_goal": "Heading on goal",
    "heading_wide": "Heading wide",
    "heading_on_bar": "Heading on crossbar",
    "heading_on_post": "Heading on post",

    "penalty_miss": "Penalty miss",

    "shot_by_team": "{{shot_description}} by {{team}}.",
    "shot_by_player": "{{shot_description}} by {{player}}, {{team}}.",

    "offside": "Offside.",
    "offside_by_team": "Offside, {{team}}.",
    "offside_by_player": "{{player}} offside, {{team}}.",

    "corner": "Corner.",
    "corner_by_team": "Corner, {{team}}.",

    "throw_in": "Throw-in.",
    "throw_in_by_team": "Throw-in, {{team}}.",

    "save": "Save.",
    "save_by_team": "Save, {{team}}.",

    "free_kick": "Freekick.",
    "free_kick_by_team": "Freekick, {{team}}.",

    "injury": "Injury.",

    "interesting_event": "Interesting event.",

    "substitution": "Substitution.",
    "substitution_team": "Substitution, {{team}}.",
    "substitution_player_in_out": "{{player_out}} out, {{player_in}} in.",

    "medical_assistance": "Medical assistance.",
    "medical_assistance_player": "Medical assistance, {{player}}."
}



// WEBPACK FOOTER //
// ./src/js/include/translations/English.js